
// PostVacanciesTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CommonPageHeading } from '../../CommonUtilities/CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../../CommonUtilities/CommonTable/CommonReactTable';
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';

export default function PostVacanciesTable({ vacancyheading, vacancyheaderName, urlParam }) {
  const [showVacancyData, setVacancyData] = useState([]);

  const vacancycolumns = [
    { Header: 'S.NO', accessor: (row, index) => index + 1 },
    { Header: () => 'Department', accessor: 'officer_name' },
    {
      Header: () => 'Vacancy File',
      accessor: 'status',
      Cell: ({ row }) => (
        <span>
          {row?.original?.status === 'Click Here' ? (
            <a href={row?.original?.signed_pdf_path} download>
              Click Here
            </a>
          ) : (
            row?.original?.status
          )}
        </span>
      )
    },
    {

      Header: () => 'Vacancy & Adequacy Details',
      accessor: 'vac_adeq_status',
      Cell: ({ row }) => (
        <span>
          {row?.original?.vac_adeq_status === 'Click here' ? (
            <a href={row?.original?.vac_adeq_esign_file_path} download>
              Click Here
            </a>
          ) : (
            row?.original?.vac_adeq_status
          )}
        </span>
      )
    }
  ];

  useEffect(() => {
    const Url = config.url.CONTEXT_READ_URL + `kgbv-public/roaster-signed-files?type=${urlParam}`;
    axios.get(Url).then((res) => {
      if (res?.data?.status === true && res?.data?.scode === '01') {
        setVacancyData(res?.data?.data);
      } else {
        setVacancyData([]);
      }
    });
  }, [urlParam]);

  return (
    <div>
      <CommonPageHeading heading={vacancyheading} back={true} />
      {showVacancyData?.length > 0 ? (
        <div className='table-responsive' style={{ padding: '2px 50px 0px 30px' }}>
          <CommonReactTable
            data={showVacancyData}
            columns={vacancycolumns}
            serachAlign='left'
            headerName={<>{vacancyheaderName}</>}
            headColumCount={20}
            pagination='false'
            search='true'
            showFooter='false'
            filename='Report'
            paginationCount='All'
          />
        </div>
      ) : (
        <div className='text-error text-center'>*** No Data Found***</div>
      )}
    </div>
  );
}
